import {Injectable} from "@angular/core";
import * as moment from "moment";
import "moment/locale/fr";

@Injectable()
export class MomentService {

  constructor() {
  }

  addDays(date: Date, dayNumber: number): Date {
    if (date != null && dayNumber != null) {
      return moment(date).add(dayNumber, "days").toDate();
    } else {
      return null;
    }
  }

  addMonths(date: Date, monthNumber: number): Date {
    if (date != null && monthNumber != null) {
      return moment(date).add(monthNumber, "months").toDate();
    } else {
      return null;
    }
  }

    formatToLocalDate(date: any) {
    return this.format(date, 'YYYY-MM-DD', 'YYYY-MM-DD');
  }

  formatDate(date: any, pattern?: string) {
    return this.format(date, 'YYYY-MM-DD', pattern);
  }

  formatDateTime(date: any, pattern?: string) {
    return this.format(date, 'YYYY-MM-DDTHH:mm:ss:SSSZ', pattern);
  }

  format(date: any, baseFormat: string, pattern?: string) {
    if (date == null) {
      return "";
    }
    if (pattern == null) {
      pattern = "DD/MM/YYYY"
    }
    let aDate = date;
    if (typeof aDate == "string") {
      let amoment = moment(aDate, baseFormat);
      return amoment.format(pattern);
    }
    return moment(date).format(pattern);
  }

  parse(dateString: string, pattern?: string) {
    if (dateString == null) {
      return null;
    }
    if (pattern == null) {
      return moment(dateString);
    }
    return moment(dateString, pattern);

  }

    isWithin6Months(debut: any, fin: any) {
        return moment(fin).add(-6, "months").isSameOrAfter(moment(debut));
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/services/moment.service.ts